import { createApiClient, ApiError } from "@marekl/adminer/api";

declare global {
  interface Window {
    __ADMINER_CONFIG__?: { apiBaseURL: string; version: string };
  }
}

const client = createApiClient({
  baseUrl: window.__ADMINER_CONFIG__?.apiBaseURL ?? "/api",
});

export { ApiError };
export const apiGet = client.get;
export const apiPost = client.post;
export const apiPut = client.put;
export const apiPatch = client.patch;
export const apiDelete = client.delete;
